import {useRef} from 'react';
import {Avatar, Popover, Stack} from '@mui/material';
import {useModal} from '../../utils';
import {ArrowDropDownOutlined, Person} from '@mui/icons-material';
import {LangSelect} from './Menu/LangSelect';
import {TechnicalSupport} from './Menu/TechnicalSupport/TechnicalSuport';

import {UserReport} from './Menu/UserReport/UserReport';
import {Logout} from './Menu/Logout';

const UserAvatar = () => {
    const ref = useRef(null);
    const contextMenu = useModal();
    const hideMenu = () => {
        contextMenu.hide();
    };

    return (
        <>
            <Stack
                onClick={contextMenu.show}
                ref={ref}
                direction='row'
                alignItems='center'
                sx={{
                    height: '36px',
                    padding: '4px',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    color: 'var(--mui-palette-action-active)',
                    backgroundColor: contextMenu.isVisible ? 'var(--mui-palette-action-hover)' : '',
                    '&:hover': {
                        backgroundColor: 'var(--mui-palette-action-hover)',
                    },
                }}
            >
                <Avatar sx={{width: 24, height: 24, color: 'var(--mui-palette-action-active)'}}>
                    <Person />
                </Avatar>
                <ArrowDropDownOutlined sx={{margin: '0 4px'}} />
            </Stack>
            <Popover
                anchorEl={ref.current}
                open={contextMenu.isVisible}
                onClose={contextMenu.hide}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                sx={{
                    '& .MuiPaper-root': {
                        width: '280px',
                        padding: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        mt: '10px',
                        backgroundColor: 'var(--mui-palette-background-paper)',
                        backgroundImage: 'none',
                    },
                }}
            >
                <LangSelect />
                <TechnicalSupport />
                <UserReport />
                <Logout afterLogout={hideMenu} />
            </Popover>
        </>
    );
};

export default UserAvatar;
